<template>
  <div>
    <el-form ref="form" :rules="rules" :model="form" label-width="80px">
      <el-form-item label="姓名" prop="name">
        <el-input v-model="form.name" />
      </el-form-item>
      <el-form-item label="說明" prop="description">
        <el-input v-model="form.description" type="textarea" />
      </el-form-item>

      <el-form-item label="email" prop="email">
        <el-input v-model="form.email" placeholder="(email為登入帳號)" type="email" />
      </el-form-item>

      <el-form-item label="角色" class="text-left">
        <el-select v-model="form.role_id" placeholder="選擇角色">
          <el-option v-for="item in roles" :key="item.id" :label="item.name" :value="item.id" />
        </el-select>
      </el-form-item>

      <el-form-item v-if="roleLabel !== '0'" label="經銷商" class="text-left">
        <selectCompany :id.sync="form.company_id" @onSelect="onSelectCompany" />
      </el-form-item>

      <el-form-item label="密碼" :prop="password">
        <el-input v-model.number="form.password" type="password" />
      </el-form-item>

      <el-form-item v-if="form.password" label="密碼確認" :prop="passwordCheck">
        <el-input v-model.number="form.passwordCheck" type="password" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit()">{{ this.user ? '存檔' : '建立' }}</el-button>
        <el-button @click="closeDialog">取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { getRolesV2, createUserV2, updateUserV2 } from '@/api/user';
import selectCompany from '@/components/select/companies.vue';
import { mapGetters } from 'vuex';
export default {
  components: { selectCompany },
  data() {
    const passwordCheck = (rule, value, callback) => {
      if (value !== this.form.password) {
        callback(new Error('密碼不相同'));
      } else {
        callback();
      }
    };
    return {
      disableCompany: false,
      form: {
        name: this.user ? this.user.name : '',
        email: this.user ? this.user.email : '',
        password: '',
        description: this.user ? this.user.description : '',
        roles: [],
        role: null,
        company_id: '',
        role_id: null,
      },
      isRootCompany: false,
      companies: [],
      rules: {
        name: [{ required: true, message: '必填', trigger: 'blur' }],
        email: [
          { required: true, message: '必填', trigger: 'blur' },
          { type: 'email', message: 'email格式錯誤', trigger: 'blur' },
        ],
        password: [{ required: true, message: '必填', trigger: 'blur' }],
        passwordCheck: [
          { required: true, message: '必填', trigger: 'blur' },
          { validator: passwordCheck, trigger: 'blur' },
        ],
      },
      roles: [],
      role: null,
    };
  },
  methods: {
    onSelectCompany() {},
    closeDialog() {
      this.$emit('closeDialog', false);
    },
    async onSubmit() {
      try {
        const valid = await this.$refs['form'].validate().catch((err) => {
          return err;
        });

        if (!valid) throw Error('驗證錯誤');
        if (this.roleLabel === '0') {
          this.form.company_id = null;
        }
        if (!this.user) {
          const data = await createUserV2(this.form);
        } else {
          const data = await updateUserV2(this.form);
        }

        this.$emit('success');
        this.$message({
          message: '設定成功',
          type: 'success',
        });
      } catch (error) {}
    },
  },
  computed: {
    password() {
      if (!this.user) {
        return 'password';
      } else {
        return '';
      }
    },
    passwordCheck() {
      if (!this.user || this.form.password) {
        return 'passwordCheck';
      } else {
        return '';
      }
    },
    ...mapGetters(['company_id', 'name']),
    ...mapGetters('variable', ['roleLabel']),
  },
  props: ['user'],
  async created() {
    this.roles = await getRolesV2({ label: this.roleLabel });
    if (this.user) {
      this.form.id = this.user.id;
      this.form.name = this.user.name;
      this.form.company_id = this.user.company_id;
      this.form.roles = this.user.roles[0];
      this.form.role_id = this.user.roles[0].id;
    }
    if (this.company_id) {
      this.form.company_id = this.company_id;
      this.disableCompany = true;
    }
  },
};
</script>
